import { DecorativeLine } from "@/components/base/DecorativeLine"
import { IndexData } from "@/features_signal/indexData"
import { getAssetsUrlWithHttp, resolveAssetImage } from "@/utils/common"
import { openExternalLink } from "@/utils/openExternalLink"
import styled from "@emotion/styled"
import { isString } from "lodash"

const ResponsibleGamingStyled = styled.section`
    font-family: Gilroy;
    margin: 0 12rem 0;
    padding-bottom: 29rem;
`

const Title = styled.h3`
    padding: 0;
    margin: 0;
    margin-top: 7rem;
    font-weight: 700;
    font-size: 16rem;
    height: 24rem;
    line-height: 24rem;
    text-align: center;
`

const Content = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
    height: 32rem;
    margin-top: 8rem;
`

const IconGaming = styled.img`
    width: 125rem;
    height: 28rem;
`

const IconFollowLogo = styled.img`
    width: 113rem;
    height: 24rem;
    object-fit: cover;
`

const IconBottom = styled.img`
    width: auto;
    height: 30rem;
    object-fit: cover;
`

const GamingLink = () => (
    <a
        href="https://www.pagcor.ph/regulatory/"
        target="_blank"
        rel="noopener noreferrer"
    >
        <IconGaming
            src={resolveAssetImage("pages/HomePage/img_gaming.webp")}
            alt="Gaming Icon"
        />
    </a>
)

export function ResponsibleGaming() {
    return (
        <ResponsibleGamingStyled>
            <DecorativeLine
                width={351}
                height={1}
                color={"#D5D5D8"}
            />
            <Title>Responsible Gaming</Title>
            {IndexData.dataBottom.value?.length > 0 ? (
                <Content>
                    <IconBottom
                        src={
                            getAssetsUrlWithHttp(IndexData.dataBottom.value[0]?.url) ||
                            resolveAssetImage("pages/HomePage/icon_follow_logo.webp")
                        }
                        alt=""
                        onClick={() => {
                            openExternalLink(IndexData.dataBottom.value[0]?.link_h5 || "")
                        }}
                    />
                    {IndexData.dataBottom.value[1]?.url ? (
                        <>
                            <DecorativeLine
                                containerStyle={{
                                    marginLeft: "32rem",
                                    marginRight: "32rem",
                                }}
                                width={1}
                                height={32}
                                color={`linear-gradient(
                                    0deg,
                                    rgba(28, 31, 35, 0.05) 0%,
                                    rgba(28, 31, 35, 0.25) 50%,
                                    rgba(28, 31, 35, 0.05) 100%
                                )`}
                            />
                            <IconBottom
                                src={getAssetsUrlWithHttp(IndexData.dataBottom.value[1]?.url)}
                                alt=""
                                onClick={() => {
                                    openExternalLink(IndexData.dataBottom.value[1]?.link_h5 || "")
                                }}
                            />
                        </>
                    ) : null}
                </Content>
            ) : (
                <Content>
                    <IconFollowLogo
                        src={
                            resolveAssetImage("pages/HomePage/icon_follow_logo.webp") ||
                            resolveAssetImage("pages/HomePage/img_gaming.webp")
                        }
                    />
                    <DecorativeLine
                        containerStyle={{
                            marginLeft: "37rem",
                            marginRight: "32rem",
                        }}
                        width={1}
                        height={32}
                        color={`linear-gradient(
                            0deg,
                            rgba(28, 31, 35, 0.05) 0%,
                            rgba(28, 31, 35, 0.25) 50%,
                            rgba(28, 31, 35, 0.05) 100%
                        )`}
                    />
                    <GamingLink />
                </Content>
            )}
        </ResponsibleGamingStyled>
    )
}
